// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"dd85c236","247":"7f9d64db","513":"5ae6b534","706":"711ede07","726":"759a3e6d","881":"3e9d4fe9"}[chunkId] + ".chunk.js";
};